import { render, staticRenderFns } from "./DeltaT.vue?vue&type=template&id=07804153&scoped=true"
import script from "./DeltaT.vue?vue&type=script&lang=js"
export * from "./DeltaT.vue?vue&type=script&lang=js"
import style0 from "./DeltaT.vue?vue&type=style&index=0&id=07804153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07804153",
  null
  
)

export default component.exports